import { render, staticRenderFns } from "./Phase.vue?vue&type=template&id=7988453a&scoped=true"
import script from "./Phase.vue?vue&type=script&lang=js"
export * from "./Phase.vue?vue&type=script&lang=js"
import style0 from "./Phase.vue?vue&type=style&index=0&id=7988453a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988453a",
  null
  
)

export default component.exports